import { PageWrapper } from '@repo/ui';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useEvaluationCriteria } from '../../hooks/useEvaluationCriteria';
import { useQuestions } from '../../hooks/useQuestions';
import { CriteriaSection } from './sections/criteria-section';
import { QuestionsSection } from './sections/questions-section';

export const EvaluationCriteriaForm = () => {
  const { id } = useParams();

  const { requestGetAllQuestions, questions } = useQuestions();
  const {
    entitiesListData,
    requestGetAllEntities,
    selectedEvaluationCriteria,
    requestGetEvaluationCriteriaById,
    requestClearSelectedEvaluationCriteria,
  } = useEvaluationCriteria();

  useEffect(() => {
    requestGetAllEntities();
  }, []);

  useEffect(() => {
    if (id) {
      requestGetEvaluationCriteriaById({ id });
      requestGetAllQuestions({ criteriaId: id });
    }

    return () => {
      requestClearSelectedEvaluationCriteria();
    };
  }, [id]);

  return (
    <PageWrapper title="Novo Instrumento de Avaliação">
      <div className="mb-4">
        <h4>{id ? 'Editar' : 'Novo'} Instrumento de Avaliação</h4>
      </div>

      <CriteriaSection
        id={id}
        criteria={selectedEvaluationCriteria}
        organizationsOptions={entitiesListData || []}
      />

      {id && <QuestionsSection id={id} questions={questions} />}
    </PageWrapper>
  );
};
